module.exports = __webpack_public_path__ + "fonts/CalibreRegularItalic.88905342.woff";